import React, { Component } from "react";
import DailyLogService from "../../services/DailyLogService";
import Moment from "moment";
import back from "../../assets/images/back.svg";
import { Link } from "react-router-dom";
import Alerts from "../common/Alerts";
import ReactImageMagnify from "react-image-magnify";
// import placeholderImage from "../../assets/images/image-placeholder.png";
import removedImgIcon from "../../assets/images/image-removed-img.svg";
import historyIcon from "../../assets/images/history-icon.svg";
import closeIcon from "../../assets/images/close-icon.svg";

class DailyLogVersion extends Component {
  state = {
    slug: this.props.match.params.slug || null,
    new_template_content: null,
    old_template_content: null,
    differences: {},
    activeTab: null,
    loading: true,
    error: null,
    noData: false,
    versions: [],
    selectedVersion: null,
    openCategories: {},
    showVersionHistory: false,
    daily_log_slug: this.props.match.params.daily_log_slug || null,
    showHistoryIcon: true,
    viewedChanges: {},
  };

  componentDidMount() {
    this.fetchVersionData();
    this.getVersion();
  }

  fetchVersionData = async () => {
    this.setState({ loading: true, error: null, noData: false });

    try {
      const { slug } = this.state;
      if (!slug) throw new Error("No slug supplied in the URL");

      const res = await DailyLogService.showDailyLogVersion(slug);
      if (!global.successStatus.includes(res.status)) {
        throw new Error(`Server responded ${res.status}`);
      }
      const version = res.data?.version;
      const dailyLogTitle = res.data?.daily_log_title;
      const new_template_content = this.parseIfString(
        res.data?.new_template_content
      );
      const old_template_content = this.parseIfString(
        res.data?.old_template_content
      );

      const hasNew = new_template_content?.sections?.length > 0;
      const hasOld = old_template_content?.sections?.length > 0;

      if (!hasNew) {
        this.setState({ loading: false, noData: true });
        return;
      }

      const differences = hasOld
        ? this.computeDifferences(old_template_content, new_template_content)
        : {};

      this.setState({
        new_template_content,
        old_template_content,
        differences,
        activeTab: new_template_content.sections[0]?.section_type ?? null,
        version,
        dailyLogTitle,
        loading: false,
      });
    } catch (err) {
      this.setState({
        loading: false,
        error: err.message || "Failed to fetch version data",
      });
    }
  };

  async getVersion(queryString = "") {
    this.setState({ loading: true });
    try {
      queryString = `daily_log_slug=${this.state.daily_log_slug}`;
      const res = await DailyLogService.DailyLogVersion(queryString);
      if (global.successStatus.includes(res.status)) {
        const versions = res.data ? res.data : [];
        this.setState({ versions });
      }
    } catch (error) {
      console.error("Error fetching versions:", error);
    }
    this.setState({ loading: false });
  }

  showVersionHistory = async () => {
    if (!this.state.showVersionHistory) {
      await this.getVersion();
    }
    this.setState((prevState) => ({
      showVersionHistory: !prevState.showVersionHistory,
      selectedVersion:
        !prevState.showVersionHistory && this.state.versions.length > 0
          ? this.state.versions[0]
          : null,
      isViewMode: true,
    }));
  };

  parseIfString = (value) => {
    if (typeof value === "string") {
      try {
        return JSON.parse(value);
      } catch (e) {
        console.error("Failed to parse template content:", e);
        return null;
      }
    }
    return value;
  };

  computeDifferences = (oldData, newData) => {
    const diff = {};
    if (!oldData?.sections || !newData?.sections) return diff;

    newData.sections.forEach((newSec, sIdx) => {
      const oldSec = oldData.sections[sIdx];
      if (!oldSec) return;

      diff[newSec.section_type] = {};
      // Compare inputs (table rows)
      newSec.inputs?.forEach((newRow, rIdx) => {
        const oldRow = oldSec.inputs?.[rIdx] || {};
        Object.keys(newRow).forEach((k) => {
          if (["row_title", "row_id"].includes(k)) return;
          if (JSON.stringify(newRow[k]) !== JSON.stringify(oldRow[k])) {
            const rowKey = newRow.row_id ?? rIdx;
            diff[newSec.section_type][rowKey] =
              diff[newSec.section_type][rowKey] || {};
            diff[newSec.section_type][rowKey][k] = {
              old: oldRow[k] ?? "",
              new: newRow[k] ?? "",
            };
          }
        });
      });

      // Compare tasks
      newSec.tasks?.forEach((t, tIdx) => {
        const oldT = oldSec.tasks?.[tIdx] || {};
        const oldVal = oldT.values?.[0];
        const newVal = t.values?.[0];
        if (oldVal !== newVal) {
          diff[newSec.section_type][`task-${tIdx}`] = {
            old: oldVal,
            new: newVal,
            label: t.label,
          };
        }
      });

      // Compare logs with more detailed reply comparison
      if (newSec.logs && oldSec.logs) {
        Object.keys(newSec.logs).forEach((cat) => {
          const newEntries = newSec.logs[cat]?.entries ?? [];
          const oldEntries = oldSec.logs[cat]?.entries ?? [];

          const changedEntries = newEntries.filter((newEntry) => {
            const oldEntry = oldEntries.find((e) => e.slug === newEntry.slug);
            if (!oldEntry) return true; // New entry

            // Compare text
            if (newEntry.text !== oldEntry.text) return true;

            // Compare images
            const newImages = newEntry.images?.map((i) => i.slug).sort() || [];
            const oldImages = oldEntry.images?.map((i) => i.slug).sort() || [];
            if (JSON.stringify(newImages) !== JSON.stringify(oldImages))
              return true;

            // Compare replies - DEEPER COMPARISON
            if (
              (newEntry.replies?.length || 0) !==
              (oldEntry.replies?.length || 0)
            )
              return true;

            // Compare each reply content
            if (newEntry.replies && oldEntry.replies) {
              for (let i = 0; i < newEntry.replies.length; i++) {
                const newReply = newEntry.replies[i];
                const oldReply = oldEntry.replies[i];

                if (!oldReply || newReply.slug !== oldReply.slug) return true;
                if (newReply.text !== oldReply.text) return true;

                // Compare reply images
                const newReplyImages =
                  newReply.images?.map((img) => img.slug).sort() || [];
                const oldReplyImages =
                  oldReply.images?.map((img) => img.slug).sort() || [];
                if (
                  JSON.stringify(newReplyImages) !==
                  JSON.stringify(oldReplyImages)
                )
                  return true;
              }
            }

            return false;
          });

          const deletedEntries = oldEntries.filter(
            (old) => !newEntries.some((newE) => newE.slug === old.slug)
          );

          if (changedEntries.length > 0 || deletedEntries.length > 0) {
            diff[newSec.section_type][`log-${cat}`] = {
              old: oldEntries,
              new: newEntries,
              metadata: {
                changedEntrySlugs: changedEntries.map((e) => e.slug),
                deletedEntrySlugs: deletedEntries.map((e) => e.slug),
                totalChanges: changedEntries.length + deletedEntries.length,
              },
            };
          }
        });
      }
    });

    return diff;
  };

  handleTabChange = (sectionType) => {
    this.setState((prevState) => ({
      activeTab: sectionType,
      viewedChanges: {
        ...(prevState.viewedChanges || {}), // Fallback to empty object
        [sectionType]: true,
      },
    }));
  };

  toggleCategory = (sectionIndex, catIndex) => {
    this.setState((prevState) => {
      const key = `${sectionIndex}-${catIndex}`;
      return {
        openCategories: {
          ...prevState.openCategories,
          [key]: !prevState.openCategories[key],
        },
      };
    });
  };

  showVersionHistory = () => {
    this.setState((prevState) => ({
      showVersionHistory: !prevState.showVersionHistory,
    }));
  };

  renderChangeIndicator = (change) => {
    if (!change) return null;

    return (
      <span
        className="change-indicator"
        title={`Changed from "${change.old}" to "${change.new}"`}
      >
        {/* <i className="fas fa-circle text-warning"></i> */}
      </span>
    );
  };

  renderTableSection = (section) => {
    const { differences } = this.state;
    if (!section.inputs || !section.columns) {
      return <p className="no-data">No table data available.</p>;
    }

    // Check if any row has a non-empty title
    const hasRowTitles = section.inputs.some(
      (input) => input.row_title && input.row_title.trim() !== ""
    );

    return (
      <div className="table-responsive tableFormatesimple">
        <table className="table table-bordered version-table">
          <thead>
            <tr>
              {/* Only show row title header if there are non-empty row titles */}
              {hasRowTitles && <th className="row-title-header"></th>}
              {section.columns.map((col, i) => (
                <th key={`col-${i}`}>{col.column_name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {section.inputs.map((row, rIdx) => {
              const rowKey = row.row_id ?? rIdx;
              const rowTitle = row.row_title?.trim() || "";

              return (
                <tr key={`row-${rowKey}`}>
                  {/* Only show row title cell if there are non-empty row titles */}
                  {hasRowTitles && (
                    <td className="row-title-cell">
                      {rowTitle || "\u00A0"} {/* &nbsp; if empty */}
                    </td>
                  )}
                  {section.columns.map((col, cIdx) => {
                    const colName = col.column_name;
                    const change =
                      differences?.[section.section_type]?.[rowKey]?.[colName];
                    const cellValue = row[colName] || "-";

                    return (
                      <td
                        key={`cell-${rowKey}-${cIdx}`}
                        className={change ? "changed-cell" : ""}
                      >
                        {change ? (
                          <div className="change-display">
                            <span className="old-value">
                              {change.old || "-"}
                            </span>
                            <span className="new-value">
                              {change.new || "-"}
                            </span>
                          </div>
                        ) : (
                          cellValue
                        )}
                        {this.renderChangeIndicator(change)}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  renderSimpleTable = (section) => {
    const { differences } = this.state;
    if (!section.inputs) {
      return <p className="no-data">No data available.</p>;
    }

    // Check if any row has a non-empty title
    const hasRowTitles = section.inputs.some(
      (input) => input.row_title && input.row_title.trim() !== ""
    );

    // Special handling for scores section
    if (section.section_type === "scores") {
      // Get column names from JSON or use defaults
      const scoreColumn =
        section.columns?.[0]?.column_name || "Numerical Score";
      const rankColumn = section.columns?.[1]?.column_name || "Rank";

      return (
        <div className="table-responsive tableFormatesimple">
          <table className="table table-bordered version-table simple-table scores-table">
            <thead>
              <tr>
                {/* Only show empty header if there are non-empty row titles */}
                {hasRowTitles && <th></th>}
                <th>{scoreColumn}</th>
                <th>{rankColumn}</th>
              </tr>
            </thead>
            <tbody>
              {section.inputs.map((row, rIdx) => {
                const rowKey = row.row_id ?? rIdx;
                const rowTitle = row.row_title?.trim() || "";

                // Get values from either direct properties or column-named properties
                const scoreValue =
                  row.numerical_score || row[scoreColumn] || "-";
                const rankValue = row.rank || row[rankColumn] || "-";

                const scoreChange =
                  differences?.[section.section_type]?.[rowKey]
                    ?.numerical_score ||
                  differences?.[section.section_type]?.[rowKey]?.[scoreColumn];
                const rankChange =
                  differences?.[section.section_type]?.[rowKey]?.rank ||
                  differences?.[section.section_type]?.[rowKey]?.[rankColumn];

                return (
                  <tr key={`row-${rowKey}`}>
                    {/* Only show row title cell if there are non-empty row titles */}
                    {hasRowTitles && (
                      <td className="row-title-cell">
                        {rowTitle || "\u00A0"} {/* &nbsp; if empty */}
                      </td>
                    )}
                    <td className={scoreChange ? "changed-cell" : ""}>
                      {scoreChange ? (
                        <div className="change-display">
                          <span className="old-value">
                            {scoreChange.old || "-"}
                          </span>
                          <span className="new-value">
                            {scoreChange.new || "-"}
                          </span>
                        </div>
                      ) : (
                        scoreValue
                      )}
                      {this.renderChangeIndicator(scoreChange)}
                    </td>
                    <td className={rankChange ? "changed-cell" : ""}>
                      {rankChange ? (
                        <div className="change-display">
                          <span className="old-value">
                            {rankChange.old || "-"}
                          </span>
                          <span className="new-value">
                            {rankChange.new || "-"}
                          </span>
                        </div>
                      ) : (
                        rankValue
                      )}
                      {this.renderChangeIndicator(rankChange)}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      );
    }

    // Default simple table rendering for other sections
    return (
      <div className="table-responsive tableFormatesimple fnb-result-table">
        <table className="table table-bordered version-table simple-table">
          <thead>
            <tr>
              {<th></th>}
              <th>{section.columns?.[0]?.column_name || "Value"}</th>
            </tr>
          </thead>
          <tbody>
            {section.inputs.map((row, rIdx) => {
              const rowKey = row.row_id ?? rIdx;
              const rowTitle = row.row_title?.trim() || "";
              const change =
                differences?.[section.section_type]?.[rowKey]?.Value;
              const cellValue = row.Value || "-";

              return (
                <tr key={`row-${rowKey}`}>
                  {/* Only show row title cell if there are non-empty row titles */}
                  {hasRowTitles && (
                    <td className="row-title-cell">
                      {rowTitle || "\u00A0"} {/* &nbsp; if empty */}
                    </td>
                  )}
                  <td className={change ? "changed-cell" : ""}>
                    {change ? (
                      <div className="change-display">
                        <span className="old-value">{change.old || "-"}</span>
                        <span className="new-value">{change.new || "-"}</span>
                      </div>
                    ) : (
                      cellValue
                    )}
                    {this.renderChangeIndicator(change)}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };

  renderTasks = (section) => {
    const { differences } = this.state;
    if (!section.tasks?.length) {
      return <p className="no-data">No tasks available.</p>;
    }

    return (
      <div className="pt-5">
        <div className="task-list">
          {section.tasks.map((task, tIdx) => {
            const change =
              differences?.[section.section_type]?.[`task-${tIdx}`];

            return (
              <div
                key={`task-${tIdx}`}
                className={`task-item ${change ? "changed-task" : ""}`}
              >
                <div className="">
                  <label className="check_cust audit-temp-checkbox mb-0">
                    <input
                      type="checkbox"
                      checked={task.values?.[0] || false}
                      readOnly
                      className="form-check-input"
                    />
                    {task.label}
                    {change && (
                      <div className="task-change-details">
                        <span className="old-value">
                          Old: {change.old ? "✅" : "❌"}
                        </span>
                        <span className="new-value">
                          New: {change.new ? "✅" : "❌"}
                        </span>
                      </div>
                    )}
                    <span className="checkmark"></span>
                  </label>
                </div>
                {/* <input
                  type="checkbox"
                  checked={task.values?.[0] || false}
                  readOnly
                />
                <label>
                  {task.label}
                  {change && (
                    <div className="task-change-details">
                      <span className="old-value">
                        Old: {change.old ? "✅" : "❌"}
                      </span>
                      <span className="new-value">
                        New: {change.new ? "✅" : "❌"}
                      </span>
                    </div>
                  )}
                </label> */}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  renderLogEntries = (section) => {
    const { differences } = this.state;
    const categories = section.categories || Object.keys(section.logs || {});

    if (!categories.length) {
      return <p className="no-data">No log entries available.</p>;
    }

    return (
      <div className="log-entries pt-5 row">
        {categories.map((cat) => {
          const entries = section.logs?.[cat]?.entries || [];
          const change = differences?.[section.section_type]?.[`log-${cat}`];
          // const newEntrySlugs = change?.metadata?.newEntrySlugs || [];

          const oldEntries = change?.old || [];

          const currentSlugs = new Set(entries.map((e) => e.slug));
          const deletedEntries = oldEntries.filter(
            (old) => !currentSlugs.has(old.slug)
          );

          return (
            <>
              <div
                className={`col-md-${
                  this.state.showVersionHistory ? "6" : "4"
                } col-lg-${
                  this.state.showVersionHistory
                    ? "6 laptop-view-screen6"
                    : "3 laptop-view-screen3"
                } col-xl-${this.state.showVersionHistory ? "6" : "3"}`}
              >
                <div
                  key={`log-cat-${cat}`}
                  className={`log-category ${
                    change ? "changed-log" : ""
                  } log-cat-${cat}`}
                >
                  <h4 className="az-content-label titleLable pl-0">
                    {cat}
                    {this.renderChangeIndicator(change)}
                  </h4>

                  {entries.length > 0 ? (
                    <ul>
                      {entries.map((entry, eIdx) => {
                        const isInNewArray = change?.new?.some(
                          (newEntry) => newEntry.slug === entry.slug
                        );
                        const isInOldArray = change?.old?.some(
                          (oldEntry) => oldEntry.slug === entry.slug
                        );
                        const isNewEntry = isInNewArray && !isInOldArray;

                        // Check if entry is modified (exists in both arrays but content changed)
                        // const isModifiedEntry = isInNewArray && isInOldArray;

                        const oldEntry = change?.old?.find(
                          (old) => old.slug === entry.slug
                        );
                        const textChanged =
                          oldEntry && oldEntry.text !== entry.text;
                        const imagesChanged =
                          oldEntry &&
                          JSON.stringify(oldEntry.images) !==
                            JSON.stringify(entry.images);
                        const repliesChanged =
                          oldEntry &&
                          JSON.stringify(oldEntry.replies) !==
                            JSON.stringify(entry.replies);

                        return (
                          <li
                            key={`entry-${eIdx}`}
                            className={`
                            ${isNewEntry ? "new-entry" : ""}
                            ${textChanged ? "text-changed" : ""}
                            ${imagesChanged ? "images-changed" : ""}
                            ${repliesChanged ? "replies-changed" : ""}
                          `}
                          >
                            <div className="entry-text">
                              <div className="old-value">
                                <>
                                  {textChanged && oldEntry && (
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: oldEntry.text,
                                      }}
                                    />
                                  )}
                                </>
                              </div>
                              <div
                                dangerouslySetInnerHTML={{ __html: entry.text }}
                                className={
                                  textChanged ? "new-value" : "text-editor-para"
                                }
                              />
                              <>
                                <div className="old-value">
                                  {textChanged && oldEntry && (
                                    <small className="old-reply-label">
                                      <b>{entry.user}</b> -{" "}
                                      {Moment(entry.timestamp).format(
                                        "DD MMM, YY - hh:mm A"
                                      )}
                                      {/* Previous version */}
                                    </small>
                                  )}
                                </div>
                              </>
                            </div>
                            <small>
                              <b>{entry.user}</b> -{" "}
                              {entry.timestamp
                                ? Moment(entry.timestamp).format(
                                    "DD MMM, YY - hh:mm A"
                                  )
                                : "Invalid date"}
                              {isNewEntry && (
                                <span className="badge bg-success ml-2">
                                  New
                                </span>
                              )}
                            </small>

                            {/* Rest of your entry rendering (images, replies, etc) */}
                            {entry.images?.length > 0 && (
                              <div className="daily_log_info_imgbox mt-2">
                                {entry.images.map((image) => {
                                  const isNewImage =
                                    oldEntry &&
                                    !oldEntry.images?.some(
                                      (img) => img.slug === image.slug
                                    );
                                  const imageUrl =
                                    image.uri_web || image.filePath;

                                  return (
                                    <a
                                      key={image.slug}
                                      href={imageUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className={`img_close ${
                                        isNewImage ? "new-image" : ""
                                      }`}
                                      onClick={(e) => e.stopPropagation()}
                                    >
                                      <div className="pop-up-image-megnify">
                                        <ReactImageMagnify
                                          {...{
                                            smallImage: {
                                              alt: "",
                                              isFluidWidth: true,
                                              src: imageUrl,
                                            },
                                            largeImage: {
                                              src: imageUrl,
                                              width: 200,
                                              height: 200,
                                            },
                                            enlargedImagePosition: "beside",
                                            enlargedImageContainerDimensions: {
                                              width: "300%",
                                              height: "300%",
                                            },
                                            className: "custom-image-magnify",
                                          }}
                                        />
                                      </div>
                                      {isNewImage && (
                                        <span className="image-change-badge">
                                          New
                                        </span>
                                      )}
                                    </a>
                                  );
                                })}
                              </div>
                            )}

                            {oldEntry?.images?.length > 0 && (
                              <div className="removed-images mt-2">
                                {oldEntry.images
                                  .filter(
                                    (oldImg) =>
                                      !entry.images?.some(
                                        (img) => img.slug === oldImg.slug
                                      )
                                  )
                                  .map((image) => {
                                    const imageUrl =
                                      image.uri_web || image.filePath;
                                    return (
                                      <a
                                        key={`removed-${image.slug}`}
                                        href={imageUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="removed-image"
                                        onClick={(e) => e.stopPropagation()}
                                      >
                                        <div className="img_close">
                                          <div className="pop-up-image-megnify">
                                            <ReactImageMagnify
                                              {...{
                                                smallImage: {
                                                  alt: "",
                                                  isFluidWidth: true,
                                                  src: imageUrl,
                                                },
                                                largeImage: {
                                                  src: imageUrl,
                                                  width: 200,
                                                  height: 200,
                                                },
                                                enlargedImagePosition: "beside",
                                                enlargedImageContainerDimensions:
                                                  {
                                                    width: "300%",
                                                    height: "300%",
                                                  },
                                                className:
                                                  "custom-image-magnify",
                                              }}
                                            />
                                          </div>
                                          <span>
                                            <img
                                              src={removedImgIcon}
                                              alt="Removed"
                                            />
                                          </span>
                                        </div>
                                      </a>
                                    );
                                  })}
                              </div>
                            )}

                            {entry.replies?.length > 0 && (
                              <div className="replies-container mt-3">
                                <h6>Replies:</h6>
                                <ul className="replies-list">
                                  {entry.replies.map((reply, rIdx) => {
                                    const oldReply = oldEntry?.replies?.find(
                                      (r) => r.slug === reply.slug
                                    );
                                    const isNewReply = oldEntry && !oldReply;
                                    const replyChanged =
                                      oldReply && oldReply.text !== reply.text;

                                    return (
                                      <div
                                        key={`reply-${rIdx}`}
                                        className={`
                                    reply-item 
                                    ${isNewReply ? "new-reply" : ""}
                                    ${replyChanged ? "changed-reply" : ""}
                                  `}
                                      >
                                        {/* Show old reply content if it changed */}
                                        {replyChanged && oldReply && (
                                          <div className="old-reply-text bg-warning-light p-2 mb-1">
                                            <div
                                              dangerouslySetInnerHTML={{
                                                __html: oldReply.text,
                                              }}
                                            />
                                            <small className="text-muted">
                                              Previous version -{" "}
                                              {Moment(
                                                oldReply.timestamp
                                              ).format("DD MMM, YY - hh:mm A")}
                                            </small>
                                          </div>
                                        )}

                                        {/* Current reply content */}
                                        <div
                                          className={`
                                    reply-content p-2
                                    ${isNewReply ? "bg-success-light" : ""}
                                    ${replyChanged ? "bg-info-light" : ""}
                                  `}
                                        >
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html: reply.text,
                                            }}
                                          />
                                          <small>
                                            <b>{reply.user}</b> -{" "}
                                            {Moment(reply.timestamp).format(
                                              "DD MMM, YY - hh:mm A"
                                            )}
                                            {isNewReply && (
                                              <span className="badge bg-success ml-2">
                                                New
                                              </span>
                                            )}
                                            {replyChanged && !isNewReply && (
                                              <span className="badge bg-warning text-dark ml-2">
                                                Modified
                                              </span>
                                            )}
                                          </small>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </ul>
                              </div>
                            )}

                            {oldEntry?.replies?.length > 0 && (
                              <div className="removed-replies mt-2">
                                {oldEntry.replies
                                  .filter(
                                    (oldReply) =>
                                      !entry.replies?.some(
                                        (reply) => reply.slug === oldReply.slug
                                      )
                                  )
                                  .map((reply) => (
                                    <div
                                      key={`removed-${reply.slug}`}
                                      className="removed-reply bg-danger-light p-2 mb-2"
                                    >
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: reply.text,
                                        }}
                                        className="text-danger"
                                      />
                                      <small className="text-danger">
                                        {reply.user} -{" "}
                                        {Moment(reply.timestamp).format(
                                          "DD MMM, YY - hh:mm A"
                                        )}
                                        <span className="badge bg-danger ml-2">
                                          Removed
                                        </span>
                                      </small>
                                    </div>
                                  ))}
                              </div>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    <p>No entries</p>
                  )}

                  {/* DELETED ENTRIES SECTION */}
                  {deletedEntries.length > 0 && (
                    <div className="deleted-entries mt-3">
                      <h6 className="text-danger">Deleted Entries:</h6>
                      <ul>
                        {deletedEntries.map((entry, idx) => (
                          <li
                            key={`deleted-entry-${idx}`}
                            className="deleted-entry bg-danger-light p-3 mb-2"
                          >
                            <div
                              dangerouslySetInnerHTML={{ __html: entry.text }}
                              className="text-danger"
                            />
                            <small className="text-danger">
                              {entry.user} -{" "}
                              {Moment(entry.timestamp).format(
                                "DD MMM, YY - hh:mm A"
                              )}
                              <span className="badge bg-danger ml-2">
                                Deleted
                              </span>
                            </small>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </>
          );
        })}
      </div>
    );
  };

  renderSection = (section, sectionIndex) => {
    if (!section?.section_type) return null;

    switch (section.section_type) {
      case "staff":
      case "key_staff":
      case "sales":
      case "forward_looking":
        return this.renderTableSection(section);
      case "scores":
      case "fnb_results":
        return this.renderSimpleTable(section);
      case "tasks":
      case "calendar":
        return this.renderTasks(section);
      case "log_entries":
        return this.renderLogEntries(section);
      default:
        return (
          <div className="unknown-section">
            <p>Unsupported section type: {section.section_type}</p>
            <pre>{JSON.stringify(section, null, 2)}</pre>
          </div>
        );
    }
  };

  hasSectionChanges = (sectionType) => {
    const { differences = {} } = this.state; // Default to empty object
    return (
      differences[sectionType] &&
      Object.keys(differences[sectionType]).length > 0
    );
  };

  // Add this method to check if changes are new/unseen
  hasNewChanges = (sectionType) => {
    const { viewedChanges = {} } = this.state; // Default to empty object if undefined
    return this.hasSectionChanges(sectionType) && !viewedChanges[sectionType];
  };

  renderLoading = () => (
    <div className="spinnerLoader1">
      <div className="toploader1">
        <img
          src={require("../../assets/images/Loader-new.gif").default}
          alt="Loading"
        />
      </div>
    </div>
  );

  renderError = () => (
    <div className="error-state">
      <h3>⚠️ Error</h3>
      <p>{this.state.error}</p>
      <button className="btn btn-primary" onClick={this.fetchVersionData}>
        Retry
      </button>
    </div>
  );

  renderNoData = () => (
    <div className="no-data-state">
      <h3>No Data Available</h3>
      <p>There is no version data to display.</p>
      <button
        className="btn btn-secondary"
        onClick={() => window.history.back()}
      >
        Go Back
      </button>
    </div>
  );

  renderVersionHistory = () => {
    const { versions, slug } = this.state; // Get current version slug from state

    return (
      <div className="version-history-panel">
        <div className="panel-header">
          <h4>Version History</h4>
          <button className="close-btn" onClick={this.showVersionHistory}>
            ×
          </button>
        </div>
        <div className="version-list">
          {versions.map((version) => (
            <Link
              key={version.version_id}
              to={`/daily-log/${this.state.daily_log_slug}/versions/${version.slug}`}
              className={`version-item ${
                slug === version.slug ? "active" : ""
              }`}
            >
              <div className="version-meta">
                {Moment(version.created_at).format("DD MMM, YY - hh:mm A")}
              </div>
              <div className="version-number">Version {version.version}</div>
              <div className="version-author">
                Edited by: {version.full_name || "Unknown"}
              </div>
            </Link>
          ))}
        </div>
      </div>
    );
  };

  toggleHistoryPanel = () => {
    this.setState((prevState) => ({
      showVersionHistory: !prevState.showVersionHistory,
      // Optionally keep the icon visible when panel is closed:
      // showHistoryIcon: prevState.showVersionHistory || true,
      showHistoryIcon: false,
    }));
  };

  render() {
    const {
      loading,
      error,
      noData,
      new_template_content,
      // old_template_content,
      activeTab,
      showVersionHistory,
    } = this.state;

    if (loading) return this.renderLoading();
    if (error) return this.renderError();
    if (noData) return this.renderNoData();

    // const hasOldVersion = old_template_content?.sections?.length > 0;

    return (
      <div>
        <main>
          <div className="container-fluid">
            <div className="row row-xs">
              <div className="col-md-12">
                <div className="dashbaord-pageHeadertitle heading_alignment">
                  <h3 className="flex-column">
                    <div className="d-flex justify-content-between align-items-center w-100">
                      <h3>Version History</h3>
                      <div className="btnNavigate d-flex justify-content-end">
                        <Link to={`/daily-log/${this.state.daily_log_slug}`}>
                          <img src={back} alt="" />
                          Back
                        </Link>
                      </div>
                    </div>
                    <span>
                      {this.state.dailyLogTitle} (Version {this.state.version})
                    </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            <div className="d-flex flex-column">
              <div className="row row-xs mg-t-0 pd-t-0">
                <div className="col-md-12">
                  <div className="scrolling-carousel pd-l-0">
                    <div className="status-buttons d-flex justify-content-between mt-3">
                      <div className="">
                        {new_template_content?.sections.map((section) => {
                          const sectionType = section.section_type;
                          const hasChanges =
                            this.hasSectionChanges(sectionType);
                          const hasNewChanges = this.hasNewChanges(sectionType);

                          return (
                            <button
                              key={sectionType}
                              className={`btn ${
                                activeTab === sectionType ? "active" : ""
                              }`}
                              onClick={() => this.handleTabChange(sectionType)}
                            >
                              {section.table_tag ||
                                sectionType.replace(/_/g, " ").toUpperCase()}
                              {hasChanges && (
                                <span
                                  className={`change-dot ${
                                    hasNewChanges ? "pulse" : ""
                                  }`}
                                  title={
                                    hasNewChanges
                                      ? "New changes in this section"
                                      : "This section has changes"
                                  }
                                />
                              )}
                            </button>
                          );
                        })}
                      </div>
                      <span className="">
                        {this.state.showHistoryIcon ? (
                          <button
                            className="history-icon-btn mr-0"
                            onClick={this.toggleHistoryPanel}
                          >
                            <img
                              src={historyIcon}
                              alt="Toggle History"
                              className={`history-icon ${
                                this.state.showVersionHistory ? "active" : ""
                              }`}
                            />
                          </button>
                        ) : (
                          <button
                            className="close-btn"
                            onClick={() =>
                              this.setState({
                                showVersionHistory: false,
                                showHistoryIcon: true,
                              })
                            }
                          >
                            <img
                              src={closeIcon}
                              alt="Toggle History"
                              className={`history-icon ${
                                this.state.showVersionHistory ? "active" : ""
                              }`}
                            />
                          </button>
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="daily-log-version">
            <div className="container-fluid">
              <div className="row m-0">
                <div className="col-md-12 pl-0 pr-0">
                  <Alerts
                    show={this.state.showAlertModal}
                    type={this.state.alertModalType}
                    title={this.state.alertModalTitle}
                    message={this.state.alertModalMessage}
                  />
                </div>

                <div
                  className={`col-md-${
                    showVersionHistory ? "8" : "12"
                  } col-lg-${
                    showVersionHistory ? "8 laptop-view-screen8" : "12"
                  } col-xl-${showVersionHistory ? "9" : "12"}
                  brandList dashboardRightcard pt-0`}
                >
                  <div className="tabNavigation">
                    <div className="version-container">
                      <div className="version-content">
                        <div className="version-sections">
                          {new_template_content?.sections.map(
                            (section, index) => (
                              <div
                                key={section.section_type}
                                className={`version-section ${
                                  activeTab === section.section_type
                                    ? "active"
                                    : ""
                                }`}
                              >
                                {/* <h3>
                                  {section.table_tag ||
                                    section.section_type
                                      .replace(/_/g, " ")
                                      .toUpperCase()}
                                </h3> */}
                                {this.renderSection(section, index)}
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {this.state.showVersionHistory && (
                  <div
                    className={`col-md-${
                      showVersionHistory ? "4" : ""
                    } col-lg-${
                      showVersionHistory ? "4 laptop-view-screen-lg4" : ""
                    } col-xl-${showVersionHistory ? "3" : ""}`}
                  >
                    <div className="version-history-bottom-panel">
                      <div className="panel-header">
                        <h4 className="az-content-label titleLable">
                          Versions
                        </h4>
                        {/* <button
                          className="close-btn"
                          onClick={() =>
                            this.setState({ showVersionHistory: false })
                          }
                        >
                          ×
                        </button> */}
                      </div>
                      <div className="version-list">
                        {this.state.versions.length > 0 ? (
                          this.state.versions.map((version, index) => (
                            <Link
                              to={`/daily-log/${this.state.daily_log_slug}/versions/${version.slug}`}
                              key={index}
                              className={`version-item ${
                                this.state.slug === version.slug ? "active" : ""
                              }`}
                              onClick={(e) => {
                                e.preventDefault();
                                this.props.history.push(
                                  `/daily-log/${this.state.daily_log_slug}/versions/${version.slug}`
                                );
                                this.setState(
                                  {
                                    slug: version.slug,
                                    loading: true,
                                  },
                                  () => {
                                    this.fetchVersionData();
                                  }
                                );
                              }}
                            >
                              <div className="version-number">
                                Version {version.version}
                              </div>
                              <div className="version-meta">
                                {Moment(version.created_at).format(
                                  "DD MMM, YY - hh:mm A"
                                )}
                              </div>
                              <div className="version-author">
                                Edited by: {version?.full_name || "Unknown"}
                              </div>
                            </Link>
                          ))
                        ) : (
                          <div className="no-versions-message">
                            No versions available
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default DailyLogVersion;
